module.exports = __webpack_public_path__ + "static/media/modeling_and_simulation.d6b5d9f9.svg";